module.exports = __webpack_public_path__ + "static/home-tanks-905c2701f448e96dbee4078abe011b9f.png";